import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getEmbeddedCustomerAgreements } from 'services/EmbeddedCustomerService'

export const useEmbeddedCustomerAgreementsQuery = (reference: string) => {
  return useQuery({
    queryKey: reactQueryKeys.embeddedCustomerAgreements(reference),
    queryFn: () => getEmbeddedCustomerAgreements(reference),
    enabled: !!reference,
  })
}
